import {toAbsoluteUrl} from '../../../helpers'
import React from 'react'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      <img src={toAbsoluteUrl('/media/logos/Logo-WF_2.png')} alt='Start logo' />
      {/*<span>Loading ...</span>*/}
    </div>
  )
}
